__turbopack_context__.v({
  "Indicator": "index-module__eElqPG__Indicator",
  "Label": "index-module__eElqPG__Label",
  "Progress": "index-module__eElqPG__Progress",
  "Track": "index-module__eElqPG__Track",
  "Value": "index-module__eElqPG__Value",
});
